import { Component, Injector } from '@angular/core';
import {
  MessageService,
  LoaderService,
  ValidationResultService,
} from '@shared';
import { CategoryService } from '@shared-data';
import { GridRowComboPricingChangeset } from '../../models';
import { RestaurantItemService } from '../../services';
import { ActivatedRoute } from '@angular/router';
import { BasePricingChangesetComponent } from '../base-pricing-changeset/base-pricing-changeset.component';
import { GridDataResult } from '@progress/kendo-angular-grid';

@Component({
  selector: 'app-combo-changeset',
  templateUrl: './combo-changeset.component.html',
  styleUrl: './combo-changeset.component.scss',
})
export class ComboChangesetComponent extends BasePricingChangesetComponent {
  currentComponentId: number | null = null;
  constructor(
    validationResultService: ValidationResultService,
    messageService: MessageService,
    loaderService: LoaderService,
    restaurantItemsService: RestaurantItemService,
    categoryService: CategoryService,
    injector: Injector,
    activatedRoute: ActivatedRoute,
  ) {
    super(
      validationResultService,
      messageService,
      loaderService,
      restaurantItemsService,
      categoryService,
      activatedRoute,
      injector,
      GridRowComboPricingChangeset,
    );
  }

  override setInitialSort(): void {
    this.initialSort = [
      { field: 'categoryOrder', dir: 'asc' },
      { field: 'sortOrder', dir: 'asc' },
    ];
  }

  override populateGrid(gridDataResult: GridDataResult): void {
    gridDataResult.data = gridDataResult.data.map((row) => {
      const gridRow = new GridRowComboPricingChangeset(row);
      
      gridRow.locked =
      this.locked ||
      (gridRow.isTwoItemCombo ?? false) ||
      (gridRow.entreeOverridden ?? false) ||
      gridRow.availabilityScheduledDate != null ||
      gridRow.pricingScheduledDate != null;
      
      return gridRow;
    });
    
    this.changeset = gridDataResult;
  }
}
